export default "__VITE_ASSET__CFjT5AD6__"